export default __webpack_public_path__ + "static/media/clouds-2.24d10a06.jpg";